import { GuardiaRow } from "../../../../components/common/PL/Table/GuardiaTable";
import { RegistroIngresoPrefill } from "../registroIngresoNavigation";

export const mapGuardiaToPrefill = (guardia: GuardiaRow): RegistroIngresoPrefill => {
  const nombreParts = (guardia.nombre || "").split(" ");
  const firstName = nombreParts[0] || "";
  const lastName = nombreParts.slice(1).join(" ");

  return {
    id: guardia.userId,
    eventId: guardia.eventId,
    documentCountry: guardia.countryCode,
    documentNumber: guardia.dni,
    firstName,
    lastName,
    email: guardia.email,
    phone: guardia.phone,
    birthdate: guardia.birthdate || null,
    sex: guardia.sex || "",
    visitorPhoto: guardia.facePhoto,
    frontDNI: guardia.frontDNI,
    backDNI: guardia.backDNI,
    vehiclePlate: guardia.patente,
    vehicleType: guardia.vehicleType,
    vehicleBrand: guardia.vehicle?.brand,
    vehicleModel: guardia.vehicle?.model,
    vehicleColor: guardia.vehicle?.color,
    selectedVehicleId: guardia.vehicle?.id || (guardia.patente ? "exit-vehicle-id" : undefined),
    inEventComment: guardia.inEventComment,
    inEventPeopleComment: guardia.inEventPeopleComment,
    inEventPhoto: guardia.inEventPhoto,
    entranceEvent: guardia.event,
    transportEmployeeNumber: guardia.transportEmployeeNumber,
    transportEmployeeNumbers: guardia.transportEmployeeNumbers,
    company: guardia.empresa,
  };
};
